export const orderStatus = [
    {
        id: 'ORIGIN',
        name: 'generic_at_origin',
        statusColor: '#188038'
    },
    {
        id: 'ACTIVATED',
        name: 'generic_ready_for_pickup',
        statusColor: '#188038'
    },
    {
        id: 'INTRANSIT',
        name: 'generic_in_transit',
        statusColor: '#188038'
    },
    {
        id: 'CP_QUOTE_REQUESTED',
        name: 'generic_quote_requested',
        statusColor: '#2daae1'
    },
    {
        id: 'CP_QUOTE_SENT',
        name: 'generic_approve_quote',
        statusColor: 'orange'
    },
    {
        id: 'CP_QUOTE_ACCEPTED',
        name: 'generic_quote_accepted',
        statusColor: '#188038'
    },
    {
        id: 'DESTINATION',
        name: 'generic_at_destination',
        statusColor: '#188038'
    },
    {
        id: 'FINISHED',
        name: 'generic_finished',
        statusColor: '#00ceb4'
    },
    {
        id: 'SUB_QUOTE_REJECTED',
        name: 'generic_quote_rejected',
        statusColor: 'red'
    },
    {
        id: 'COMPLETED_DRAFT',
        name: 'generic_completed_draft',
        statusColor: '#00ceb4'
    },
    {
        id: 'CANCELLED_DRAFT',
        name: 'generic_cancelled_draft',
        statusColor: 'red'
    },
    {
        id: 'CANCELLED_ACTIVE',
        name: 'generic_cancelled_active',
        statusColor: 'red'
    },
    {
        id: 'COLLECTED',
        name: 'generic__collected',
        statusColor: '#188038'
    },
    {
        id: 'DELIVERED',
        name: 'generic__delivered',
        statusColor: '#188038'
    },
    {
        id: 'DESTIN',
        name: 'generic_at_destination',
        statusColor: '#188038'
    },
    {
        id: 'CANCELLED_TRANSIT',
        name: 'generic_cancelled_transit',
        statusColor: 'red'
    },
    {
        id: 'END_COMPLETED',
        name: 'generic_end_completed',
        statusColor: '#00ceb4'
    },
    {
        id: 'OM_DRAFT',
        name: 'generic_draft',
        statusColor: '#FCA81D'
    },
    {
        id: 'OM_INCOMPLETE',
        name: 'generic_incomplete',
        statusColor: '#FCA81D'
    },
    {
        id: 'SUBMIT_PENDING',
        name: 'generic_pending_approval',
        statusColor: '#2daae1'
    },
    {
        id: 'SUBMIT_APPROVED',
        name: 'generic_order_approved',
        statusColor: '#188038'
    },
    {
        id: 'SUBMIT_REJECTED',
        name: 'generic_order_rejected',
        statusColor: '#d93025'
    },
    {
        id: 'BOOKING_CONFIRMED',
        name: 'generic_booking_confirmed',
        statusColor: '#188038'
    }
];

export const activeStatus = [
    { id: 'ORIGIN', name: 'generic_at_origin', color: '#188038', active: false, mode: 'MATERIAL_ORDER' },
    { id: 'CP_QUOTE_SENT', name: 'generic_approve_quote', color: 'orange', active: false, mode: 'SALES_ORDER' },
    { id: 'CP_QUOTE_REQUESTED', name: 'generic_quote_requested', color: '#2daae1', active: false, mode: 'SALES_ORDER' },
    { id: 'CP_QUOTE_ACCEPTED', name: 'generic_quote_accepted', color: '#188038', active: false, mode: 'SALES_ORDER' },
    { id: 'INTRANSIT', name: 'generic_in_transit', color: '#188038', active: false, mode: 'ALL' },
    { id: 'ACTIVATED', name: 'generic_ready_for_pickup', color: '#188038', active: false, mode: 'ALL' },
    { id: 'DESTINATION', name: 'generic_at_destination', color: '#188038', active: false, mode: 'SALES_ORDER' },
    { id: 'COLLECTED', name: 'generic__collected', color: '#188038', active: false, mode: 'MATERIAL_ORDER' },
    { id: 'DESTIN', name: 'generic_at_destination', color: '#188038', active: false, mode: 'MATERIAL_ORDER' },
    { id: 'OM_DRAFT', name: 'generic_draft', color: '#FCA81D', active: false, mode: 'MATERIAL_ORDER' },
    { id: 'OM_INCOMPLETE', name: 'generic_incomplete', color: '#FCA81D', active: false, mode: 'MATERIAL_ORDER' },
    { id: 'SUBMIT_PENDING', name: 'generic_pending_approval', color: '#2daae1', active: false, mode: 'MATERIAL_ORDER' },
    { id: 'SUBMIT_APPROVED', name: 'generic_order_approved', color: '#188038', active: false, mode: 'MATERIAL_ORDER' },
    { id: 'SUBMIT_REJECTED', name: 'generic_order_rejected', color: '#d93025', active: false, mode: 'MATERIAL_ORDER' },
    { id: 'BOOKING_CONFIRMED', name: 'generic_booking_confirmed', color: '#188038', active: false, mode: 'MATERIAL_ORDER' }
];

export const finishedStatus = [
    { id: 'FINISHED', name: 'generic_finished', color: '#00ceb4', active: false, mode: 'SALES_ORDER' },
    { id: 'FINISHED_MANUALLY', name: 'generic_finished_manually', color: '#00ceb4', active: false, mode: 'SALES_ORDER' },
    { id: 'COMPLETED_DRAFT', name: 'generic_completed_draft', color: '#00ceb4', active: false, mode: 'SALES_ORDER' },
    { id: 'SUB_QUOTE_REJECTED', name: 'generic_quote_rejected', color: 'red', active: false, mode: 'SALES_ORDER' },
    { id: 'CANCELLED_ACTIVE', name: 'generic_cancelled_active', color: 'red', active: false, mode: 'ALL' },
    { id: 'CANCELLED_DRAFT', name: 'generic_cancelled_draft', color: 'red', active: false, mode: 'ALL' },
    { id: 'CANCELLED_TRANSIT', name: 'generic_cancelled_transit', color: 'red', active: false, mode: 'ALL' },
    { id: 'END_COMPLETED', name: 'generic_end_completed', color: '#00ceb4', active: false, mode: 'ALL' },
    { id: 'DELIVERED', name: 'generic__delivered', color: '#188038', active: false, mode: 'MATERIAL_ORDER' }
];

/* return {
    ACTIVATED: { name: 'salesStatus.ACTIVATED', type: StatusType.NO_ACTION },
    CP_QUOTE_ACCEPTED: { name: 'salesStatus.CP_QUOTE_ACCEPTED', type: StatusType.NO_ACTION },
    CP_QUOTE_REJECTED: { name: 'salesStatus.CP_QUOTE_REJECTED', type: StatusType.REJECTED },
    CP_QUOTE_REQUESTED: { name: 'salesStatus.CP_QUOTE_REQUESTED', type: StatusType.ACTION },
    CP_QUOTE_SENT: { name: 'salesStatus.CP_QUOTE_SENT', type: StatusType.ACTION },
    DESTINATION: { name: 'salesStatus.DESTINATION', type: StatusType.NO_ACTION },
    END_CANCEL_ANTE: { name: 'salesStatus.END_CANCEL_ANTE', type: StatusType.REJECTED },
    END_CANCEL_POST: { name: 'salesStatus.END_CANCEL_POST', type: StatusType.REJECTED },
    END_CANCELLED: { name: 'salesStatus.END_CANCELLED', type: StatusType.REJECTED },
    CANCELLED_DRAFT: { name: 'salesStatus.END_CANCELLED', type: StatusType.REJECTED },
    CANCELLED_ACTIVE: { name: 'salesStatus.END_CANCELLED', type: StatusType.REJECTED },
    CANCELLED_TRANSIT: { name: 'salesStatus.END_CANCELLED', type: StatusType.REJECTED },
    END_COMPLETED: { name: 'salesStatus.END_COMPLETED', type: StatusType.NO_ACTION },
    FINISHED: { name: 'salesStatus.FINISHED', type: StatusType.NO_ACTION },
    INTRANSIT: { name: 'salesStatus.INTRANSIT', type: StatusType.NO_ACTION },
    OM_DRAFT: { name: 'salesStatus.OM_DRAFT', type: StatusType.NO_ACTION },
    OM_INCOMPLETE: { name: 'salesStatus.OM_INCOMPLETE', type: StatusType.ACTION },
    OM_PROCESSING: { name: 'salesStatus.OM_PROCESSING', type: StatusType.ACTION },
    QUOTE_SENT: { name: 'salesStatus.QUOTE_SENT', type: StatusType.ACTION },
    RATE_PROVIDED: { name: 'salesStatus.RATE_PROVIDED', type: StatusType.NO_ACTION },
    RATE_REQUEST: { name: 'salesStatus.RATE_REQUEST', type: StatusType.ACTION },
    SUB_QUOTE_REJECTED: { name: 'salesStatus.SUB_QUOTE_REJECTED', type: StatusType.REJECTED },
}; */
